var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-03-solid-rounded 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0006 2C7.45825 2 5.04361 3.54577 4.03486 5.97145C2.55293 9.53495 5.33521 13.9544 7.89761 16.3915C8.51451 16.9782 9.06178 17.5833 10.0006 17.5833C10.901 17.5833 11.4626 17.0018 12.0665 16.4296L12.0674 16.4288C14.6439 13.9872 17.4559 9.55321 15.9665 5.97145C14.9577 3.54577 12.543 2 10.0006 2ZM10.0002 5.95833C8.61946 5.95833 7.50021 7.07762 7.50021 8.45833C7.50021 9.83908 8.61946 10.9583 10.0002 10.9583C11.381 10.9583 12.5002 9.83908 12.5002 8.45833C12.5002 7.07762 11.381 5.95833 10.0002 5.95833Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8916a082863ff3147c32950729104a03.svg";
export { ForwardRef as ReactComponent };